<template>
  <div>
    <div class="gauge-title">
      <span ref="gauge-value" v-if="top" :class="gaugeValueClass"></span>
      <span v-if="top" :class="gaugeValueClass">{{unit}}</span>
    </div>
    <canvas ref="gauge" :height="height" :width="width"></canvas>
    <div class="gauge-title">
      <span ref="gauge-value" v-if="!top" :class="gaugeValueClass"></span>
      <span v-if="!top" :class="gaugeValueClass">{{unit}}</span>
    </div>
  </div>
</template>

<script>
import {Gauge} from 'gaugeJS/dist/gauge.min';

export default {
  name: 'XugarGauge',
  props: {
    unit: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '200px'
    },
    width: {
      type: String,
      default: '200px'
    },
    decimalPlace: {
      type: Number,
      default: 0
    },
    gaugeValueClass: {
      type: String,
      default: ''
    },
    top: {
      type: Boolean,
      default: false
    },
    maxValue: {
      type: Number,
      default: 100
    },
    minValue: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function () {
        return {
          angle: -0.15,
          lineWidth: 0.44,
          radiusScale: 1,
          pointer: {
            length: 0.6,
            strokeWidth: 0.035,
            color: '#000000'
          },
          limitMax: false,
          limitMin: false,
          colorStart: '#6FADCF',
          colorStop: '#8FC0DA',
          strokeColor: '#E0E0E0',
          generateGradient: true
        };
      }
    },
    animationSpeed: {
      type: Number,
      default: 10
    },
    initialValue: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 50
    }
  },
  data () {
    return {
      gauge: null
    };
  },
  mounted () {
    this.initializeGauge();
  },
  watch: {
    value: function (newVal) {
      this.gauge.setMinValue(this.minValue);
      this.gauge.maxValue = this.maxValue;
      this.gauge.setOptions(this.options);
      this.gauge.set(newVal);
    }
  },
  methods: {
    initializeGauge () {
      this.gauge = new Gauge(this.$refs.gauge);
      this.gauge.maxValue = this.maxValue;
      this.gauge.setMinValue(this.minValue);
      this.gauge.animationSpeed = this.animationSpeed;
      this.gauge.setOptions(this.options);
      this.gauge.setTextField(this.$refs['gauge-value'], this.decimalPlace);
      this.gauge.set(this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables";

  .gauge-title span {
    display: inline;
    text-align: center;
  }

  canvas {
    margin-top: -8rem;
    width: 33%;
    @media (max-width: $screen-xxl) {
      margin-top: -7rem;
      width: 42%;
    }
    @media (max-width: $screen-xl) {
      margin-top: -3rem;
      width: 55%;
    }
    @media (max-width: $screen-l) {
      margin-top: -1rem;
      width: 65%;
    }
    @media (max-width: $screen-m) {
      margin-top: 1.7rem;
      width: 95%;
    }
  }

  .canvas {
    display: contents !important;
  }

  .gauge-title {
    position: absolute;
    width: 100%;
    font-size: $fs-s;
    margin-top: 10%;
    @media (max-width: $screen-xl) {
      margin-top: 20%;
    }
    @media (max-width: $screen-l) {
      margin-top: 30%;
    }
    @media (max-width: $screen-m) {
      margin-top: 50%;
    }
  }

  .gauge-value:first-of-type {
    font-weight: bold;
    display: grid;
    margin-bottom: -$sp-margin;
    font-size: $fs-4xl;
    @media (max-width: $screen-xxl) {
      font-size: $fs-3xl;
      margin-bottom: -$sp-margin-smaller;
    }
    @media (max-width: $screen-xl) {
      margin-bottom: -$sp-margin-small;
      font-size: $fs-2xl;
    }
    @media (max-width: $screen-l) {
      font-size: $fs-2xl;
      margin-bottom: -$sp-margin-small;
    }
  }

  .gauge-value {
    font-size: $fs-2xl;
    @media (min-width: $screen-xxl) {
      margin-top: -$sp-margin-large;
    }
    @media (max-width: $screen-xl) {
      font-size: $fs-xl;
    }
    @media (max-width: $screen-l) {
      font-size: $fs-l;
    }
  }

</style>



// WEBPACK FOOTER //
// src/brand/xugarhero/components/XugarGauge.vue